module.exports = __webpack_public_path__ + "media/1-laserbeamer-popup.mp4";